import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useState } from 'react';
import '../styles/App.css';
import Header from './Header.js';
import Home from './Home.js';
import ModeItem from './ModeItem.js';
import ModeGame from './ModeGame.js';
import ModeCharacter from './ModeCharacter.js';
import ModeSword from './ModeSword.js';
import Share from './Share.js';
import Socials from './Socials.js';
import Footer from './Footer.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import About from './About.js';
import Contact from './Contact.js';
import Terms from './Terms.js';


import Ads from './Ads.js'; 

function App() {


  return (
      <div className="home-container">
        
        <div className="pub-mobile">
          <Ads slot="8876856463" format="auto" />
        </div>

        <div className="pub-rail-gauche">
          <Ads slot="8876856463" format="vertical" />
        </div>

        { /* <button onClick={toggleDarkMode}>test</button> */ }
        <Router>
            <Header />
            <Routes>
              <Route exact path="/"  element={<Home />} />
              <Route exact path="/item"  element={<ModeItem />} />
              <Route exact path="/game"  element={<ModeGame />} />
              <Route exact path="/character"  element={<ModeCharacter />} />
              <Route exact path="/sword"  element={<ModeSword />} />
              <Route exact path="/privacy"  element={<PrivacyPolicy />} />
              <Route exact path="/terms"  element={<Terms />} />
              <Route exact path="/about"  element={<About />} />
              <Route exact path="/contact"  element={<Contact />} />
            </Routes> 
        </Router>  
        <Share />
        <Socials />
        <Footer />
        
        <div className="pub-rail-droit">
          <Ads slot="8876856463" format="vertical" />
        </div>
    </div>
	)
}

export default App
